import { computed, ref } from "vue"
import { FileData } from "./useFiles"
import store from "@/store/store"
import { ModuleNamespaces } from "@/store/types/storeGlobalTypes"
import { documentOnlineActions } from '@/store/modules/documentOnline/documentOnlineTypes'

interface ResponseUseWopi {
  editDocumentOnline: (file: FileData) => void
}

const urlService = process.env.VUE_APP_WOPI_URL

export default function useWopi(): ResponseUseWopi {

  const requestToken = ref('')
  const requestTokenTtl = ref('')
  const fileToken = ref('')
  const applicationType = ref('')

  const userId = computed(() => store.getters[`${ModuleNamespaces.AUTH}/getUserId`].toString())
  const fileSize = computed(() => store.getters[`${ModuleNamespaces.DOCUMENT_ONLINE}/getFileSize`].toString())
  const fileAction = computed(() => store.getters[`${ModuleNamespaces.DOCUMENT_ONLINE}/getFileAction`].toString())

  const saveFileName = async (fileName: string) => {
    await store.dispatch(`${ModuleNamespaces.DOCUMENT_ONLINE}/saveFileName`, fileName)
  }

  const fetchRequestToken = async (formData: FormData) => {
    await store.dispatch(`${ModuleNamespaces.DOCUMENT_ONLINE}/fetchRequestToken`, formData)
    requestToken.value = store.getters[`${ModuleNamespaces.DOCUMENT_ONLINE}/getRequestToken`]
    requestTokenTtl.value = store.getters[`${ModuleNamespaces.DOCUMENT_ONLINE}/getRequestTokenTtl`]
  }

  const fetchAppType = async (formData: FormData) => {
    await store.dispatch(`${ModuleNamespaces.DOCUMENT_ONLINE}/fetchAppType`, formData)
    applicationType.value = store.getters[`${ModuleNamespaces.DOCUMENT_ONLINE}/getApplicationType`]
  }

  const fetchFileToken = async (id: string) => {
    await store.dispatch(`${ModuleNamespaces.DOCUMENT_ONLINE}/fetchFileToken`, id)
    fileToken.value = store.getters[`${ModuleNamespaces.DOCUMENT_ONLINE}/getFileToken`]
  }

  const saveFileUrl = (url: string) => {
    store.dispatch(`${ModuleNamespaces.DOCUMENT_ONLINE}/saveFileUrl`, url)
  }

  const resetFileUrl = () => {
    store.dispatch(`${ModuleNamespaces.DOCUMENT_ONLINE}/resetFileUrl`)
  }

  const saveFileAction = (action: string) => {
    store.dispatch(`${ModuleNamespaces.DOCUMENT_ONLINE}/saveFileAction`, action)
  }

  const editDocumentOnline = async (file: FileData) => {

    saveFileAction(documentOnlineActions.EDIT)
    saveFileName(file.originalFileName)

    const formData = new FormData()
    formData.set('FileName', file.originalFileName)
    formData.set('FileVersion', Date.now().toString())
    formData.set('wopiUserId', userId.value)

    await fetchRequestToken(formData)
    formData.set('AccessToken', requestToken.value)
    formData.set('AccessTokenTtl', requestTokenTtl.value)

    await fetchAppType(formData)
    await fetchFileToken(file.id.toString())

    const url = `${process.env.VUE_APP_FILE_EDIT_URL}${fileToken.value}`
    formData.set('FileUrl', url)
    saveFileUrl(url)
    openFile(formData)
  }

  const openFile = (formData: FormData) => {

    const form = document.createElement('form');
    form.method = 'post'
    form.action = urlService
    form.target = '_blank'
    form.name = 'editFileOnline'
    form.enctype = 'application/x-www-form-urlencoded'

    formData.set('FileSize', fileSize.value)
    formData.set('Action', fileAction.value)
    formData.set('Application', applicationType.value)
    formData.set('OwnerId', 'not-defined')
    formData.set('wopiUserName', 'es-ES')
    formData.set('wopiLocale', 'es-ES')

    formData.forEach(function (value, key) {
      if (typeof value === 'string') {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value = value
        form.appendChild(input)
      }
    })

    document.body.appendChild(form);
    form.submit()

    clear(form)
  }

  const clear = (form: HTMLFormElement) => {
    document.body.removeChild(form)
    resetFileUrl()
  }

  return {
    editDocumentOnline
  }
}
